import React, { useEffect } from "react";
import { X, Check, AlertCircle } from "react-feather";

const ModernPopup = ({
  isOpen,
  onClose,
  message,
  isError,
  type = "alert", // alert | confirm
  resolver,
}) => {
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "unset";
    return () => (document.body.style.overflow = "unset");
  }, [isOpen]);

  if (!isOpen) return null;

  const handleCancel = () => {
    resolver?.({ isConfirmed: false });
    onClose();
  };

  const handleConfirm = () => {
    resolver?.({ isConfirmed: true });
    onClose();
  };

  return (
    <div className="popup-overlay">
      <div className={`popup-container ${isError ? "error" : "success"}`}>
        <button className="popup-close" onClick={handleCancel}>
          <X size={20} />
        </button>

        <div className="popup-icon">
          {isError ? <AlertCircle size={44} /> : <Check size={44} />}
        </div>

        <h3 className="popup-title">
          {type === "confirm" ? "Confirmation" : isError ? "Error" : "Success"}
        </h3>

        <p className="popup-message">{message}</p>

        <div className="popup-actions">
          {type === "confirm" ? (
            <>
              <button
                className="popup-button cancel-button"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                className="popup-button success-button"
                onClick={handleConfirm}
              >
                Yes
              </button>
            </>
          ) : (
            <button
              className={`popup-button ${
                isError ? "error-button" : "success-button"
              }`}
              onClick={handleCancel}
            >
              OK
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModernPopup;
